/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { JSONMap as e } from "../../core/jsonMap.js";
import { getJsonType as i } from "../../geometry/support/jsonUtils.js";
var t = new e({
  esriGeometryRelationCross: "cross",
  esriGeometryRelationDisjoint: "disjoint",
  esriGeometryRelationIn: "in",
  esriGeometryRelationInteriorIntersection: "interior-intersection",
  esriGeometryRelationIntersection: "intersection",
  esriGeometryRelationLineCoincidence: "line-coincidence",
  esriGeometryRelationLineTouch: "line-touch",
  esriGeometryRelationOverlap: "overlap",
  esriGeometryRelationPointTouch: "point-touch",
  esriGeometryRelationTouch: "touch",
  esriGeometryRelationWithin: "within",
  esriGeometryRelationRelation: "relation"
});

function o(e) {
  var _e$toJSON = e.toJSON(),
      o = _e$toJSON.geometries1,
      r = _e$toJSON.geometries2,
      n = _e$toJSON.relation,
      s = _e$toJSON.relationParameter,
      a = {};

  if (o && o.length) {
    a.geometries1 = JSON.stringify({
      geometryType: i(o[0]),
      geometries: o
    });
    var _e = o[0].spatialReference;
    a.sr = _e.wkid ? _e.wkid : JSON.stringify(_e);
  }

  return r && r.length > 0 && (a.geometries2 = JSON.stringify({
    geometryType: i(r[0]),
    geometries: r
  })), n && (a.relation = t.toJSON(n)), s && (a.relationParam = s), a;
}

export { o as relationToRESTParameters };